<template>
  <footer class="py-4 text-gray-100 bg-center md:bg-cover bg-no-repeat bg-[#044e7d]">
    <div class="container mx-auto flex flex-col items-center text-sm">
      <div class="font-bold">Para más información puede escribirnos a <a href="mailto: cumbrelogistica@cfi.org.ar" class="underline cursor-pointer">cumbrelogistica@cfi.org.ar</a></div>
      <div class="text-xs my-2">© 2026 QREventos.com</div>
    </div>
  </footer>

</template>


<script>
import VueScrollTo from 'vue-scrollto';

export default {
  name: 'FooterSection',
  methods: {
    scrollToForm() {
      VueScrollTo.scrollTo('#formulario', 500, {
        easing: 'ease-in-out',
      });
    },
  },
}

</script>